module.exports = __webpack_public_path__ + "media/images/basic_logos/close-blue-d5e5ac36155ad7460abe053fd8398ac1.svg";